import IndexPage from '../pages/Index/index';
import PricingPage from '../pages/Pricing/index';
import AgreementPage from '../pages/Agreement/index';
import ApiKeysPage from '../pages/ApiKeys/index';
import ToolsPage from '../pages/Tools/index';
import ToolDetailPage from '../pages/Tools/ToolDetail/index';
import TimelinePage from '../pages/Tools/Timeline/index';

const router = [
  {
    path: '/agreement',
    name: 'Pix2Text (P2T) - Free Mathpix Alternative - agreement',
    component: AgreementPage,
  },
  {
    path: '/pricing',
    name: 'Pix2Text (P2T) - Free Mathpix Alternative - buy',
    component: PricingPage,
  },
  {
    path: '/api-keys',
    name: 'Pix2Text (P2T) - API Keys Management',
    component: ApiKeysPage,
  },
  {
    path: '/tools/timeline',
    exact: true,
    name: 'Pix2Text (P2T) - Timeline Visualizer',
    component: TimelinePage,
  },
  {
    path: '/tools/:toolId',
    name: 'Pix2Text (P2T) - Tools',
    component: ToolDetailPage,
  },
  {
    path: '/tools',
    exact: true,
    name: 'Pix2Text (P2T) - Tools Marketplace',
    component: ToolsPage,
  },
  {
    path: '/',
    exact: true,
    name: 'Pix2Text (P2T) - Free Mathpix Alternative',
    component: IndexPage,
  },
];

export default router;
